import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/img/del.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-677afcdf")

_pushScopeId("data-v-677afcdf")
const _hoisted_1 = { class: "bg-ff content" }
const _hoisted_2 = { class: "flex alignC mar-b-30 mar-l-30" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("返回上一级")
const _hoisted_4 = { class: "padding-30" }
const _hoisted_5 = { style: {} }
const _hoisted_6 = { class: "flex flexR mar-t-12 bold" }
const _hoisted_7 = /*#__PURE__*/_createVNode("div", null, "总金额：", -1)
const _hoisted_8 = { class: "flex flexC alignC mar-t-22" }
const _hoisted_9 = /*#__PURE__*/_createVNode("span", { class: "c-ff" }, "提交", -1)
const _hoisted_10 = /*#__PURE__*/_createTextVNode("返回")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_form = _resolveComponent("el-form")
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_editList = _resolveComponent("editList")
  const _component_el_table = _resolveComponent("el-table")
  const _component_el_dialog = _resolveComponent("el-dialog")
  const _directive_loading = _resolveDirective("loading")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_el_button, {
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.back(-1)))
      }, {
        default: _withId(() => [
          _hoisted_3
        ]),
        _: 1
      })
    ]),
    _withDirectives(_createVNode("div", _hoisted_4, [
      _createVNode("div", null, [
        _createVNode(_component_el_form, {
          ref: "formRef",
          model: _ctx.form,
          rules: _ctx.formRules,
          inline: true,
          "label-width": "80px"
        }, {
          default: _withId(() => [
            _createVNode(_component_el_form_item, {
              label: "单据日期",
              "label-width": "100px"
            }, {
              default: _withId(() => [
                _createVNode(_component_el_button, { class: "width-211" }, {
                  default: _withId(() => [
                    _createTextVNode(_toDisplayString(_ctx.form.date), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "维修车辆",
              "label-width": "80px"
            }, {
              default: _withId(() => [
                _createVNode(_component_el_button, {
                  onClick: _ctx.getCarList,
                  class: "width-211"
                }, {
                  default: _withId(() => [
                    _createTextVNode(_toDisplayString(_ctx.form.car_name), 1)
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "采购员",
              prop: "employee_id",
              "label-width": "80px"
            }, {
              default: _withId(() => [
                _createVNode(_component_el_select, {
                  modelValue: _ctx.form.employee_id,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.form.employee_id = $event)),
                  filterable: "",
                  placeholder: "请选择",
                  class: "width-211"
                }, {
                  default: _withId(() => [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.PurchaseManList, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item,
                        label: item.nickname,
                        value: item.id
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "供应商",
              prop: "supplier_id",
              "label-width": "100px"
            }, {
              default: _withId(() => [
                _createVNode(_component_el_select, {
                  modelValue: _ctx.form.supplier_id,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.form.supplier_id = $event)),
                  filterable: "",
                  placeholder: "请选择",
                  class: "width-211"
                }, {
                  default: _withId(() => [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.supplierList, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item,
                        label: item.supplier_name,
                        value: item.supplier_id
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "实际采购单号",
              "label-width": "400px"
            }, {
              default: _withId(() => [
                _createVNode(_component_el_input, {
                  class: "width-211",
                  modelValue: _ctx.form.purchase_sh,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.form.purchase_sh = $event)),
                  autocomplete: "off"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "备注",
              "label-width": "100px"
            }, {
              default: _withId(() => [
                _createVNode(_component_el_input, {
                  style: {"width":"600px"},
                  modelValue: _ctx.form.purchase_desc,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.form.purchase_desc = $event)),
                  autocomplete: "off"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ]),
      _createVNode(_component_editList, {
        partsData: _ctx.form.parts,
        show_add: true,
        onBtn_add: _ctx._editlist_add
      }, {
        default: _withId(() => [
          _createVNode(_component_el_table_column, {
            label: "配件名称",
            width: "250"
          }, {
            default: _withId((scope) => [
              _createVNode("div", _hoisted_5, [
                _createVNode("img", {
                  onClick: ($event: any) => (_ctx._defItem(scope.$index)),
                  src: _imports_0,
                  class: "wh-24"
                }, null, 8, ["onClick"]),
                _createVNode(_component_el_input, {
                  modelValue: scope.row.name,
                  "onUpdate:modelValue": ($event: any) => (scope.row.name = $event),
                  class: "mar-l-16",
                  style: {"width":"160px"}
                }, null, 8, ["modelValue", "onUpdate:modelValue"])
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            label: "规格",
            "min-width": "100"
          }, {
            default: _withId((scope) => [
              _createVNode(_component_el_input, {
                modelValue: scope.row.specification,
                "onUpdate:modelValue": ($event: any) => (scope.row.specification = $event)
              }, null, 8, ["modelValue", "onUpdate:modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            label: "编码",
            "min-width": "100"
          }, {
            default: _withId((scope) => [
              _createVNode(_component_el_input, {
                modelValue: scope.row.encoding,
                "onUpdate:modelValue": ($event: any) => (scope.row.encoding = $event)
              }, null, 8, ["modelValue", "onUpdate:modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            label: "采购单价",
            "min-width": "125",
            align: "center"
          }, {
            default: _withId((scope) => [
              _createVNode(_component_el_input, {
                modelValue: scope.row.unit_price,
                "onUpdate:modelValue": ($event: any) => (scope.row.unit_price = $event),
                onInput: _ctx.calTotalPrice,
                style: {"width":"80px","text-align":"center"}
              }, null, 8, ["modelValue", "onUpdate:modelValue", "onInput"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            label: "数量",
            "min-width": "125",
            align: "center"
          }, {
            default: _withId((scope) => [
              _createVNode(_component_el_input, {
                modelValue: scope.row.number,
                "onUpdate:modelValue": ($event: any) => (scope.row.number = $event),
                class: "mar-l-16",
                onInput: _ctx.calTotalPrice,
                style: {"width":"80px"}
              }, null, 8, ["modelValue", "onUpdate:modelValue", "onInput"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["partsData", "onBtn_add"]),
      _createVNode("div", _hoisted_6, [
        _hoisted_7,
        _createVNode("div", null, _toDisplayString(_ctx.totalPrice), 1)
      ]),
      _createVNode("div", _hoisted_8, [
        _createVNode(_component_el_button, {
          class: "bg-red",
          onClick: _ctx._onsubmit
        }, {
          default: _withId(() => [
            _hoisted_9
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_el_button, {
          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$router.back(-1)))
        }, {
          default: _withId(() => [
            _hoisted_10
          ]),
          _: 1
        })
      ]),
      _createVNode(_component_el_dialog, {
        "model-value": _ctx.car_dialog_show,
        width: 500,
        "before-close": ()=>{_ctx.car_dialog_show = false}
      }, {
        default: _withId(() => [
          _createVNode(_component_el_input, {
            type: "text",
            "prefix-icon": "el-icon-search",
            style: {"width":"180px"},
            ref: "inputref",
            placeholder: "输入车牌号码搜索",
            modelValue: _ctx.dialog_search,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.dialog_search = $event)),
            onChange: _ctx.get_dialog_data
          }, null, 8, ["modelValue", "onChange"]),
          _withDirectives(_createVNode(_component_el_table, {
            class: "mar-t-10",
            data: _ctx.dialog_data,
            stripe: "",
            border: "",
            style: {"width":"100%"},
            "max-height": "350",
            onCurrentChange: _ctx._table_select_carcode,
            onSelectionChange: _ctx.handleSelectionChange,
            "header-cell-style": "{background-color: #f2f5f9, height: 48px, text-align: center}"
          }, {
            default: _withId(() => [
              _createVNode(_component_el_table_column, {
                align: "center",
                prop: "ordersn",
                label: "单据编号",
                "min-width": 84
              }),
              _createVNode(_component_el_table_column, {
                align: "center",
                prop: "car_code",
                label: "车牌号",
                "min-width": 84
              }),
              _createVNode(_component_el_table_column, {
                align: "center",
                prop: "category_name",
                label: "车辆型号",
                "min-width": 84
              }),
              _createVNode(_component_el_table_column, {
                align: "center",
                prop: "meet_vehicle",
                label: "接车人",
                "min-width": 84
              }),
              _createVNode(_component_el_table_column, {
                align: "center",
                prop: "create_time_text",
                label: "开单时间",
                "min-width": 84
              })
            ]),
            _: 1
          }, 8, ["data", "onCurrentChange", "onSelectionChange"]), [
            [_directive_loading, _ctx.dialog_isload]
          ])
        ]),
        _: 1
      }, 8, ["model-value", "before-close"])
    ], 512), [
      [_directive_loading, _ctx.is_load]
    ])
  ]))
})